const Getters = {
  getSuppliersFromState: (state) => {
    return state.suppliers
  },
  getSupplier: (state) => (supplierId) => {
    return state.suppliers.find(
      (supplier) => supplier.supplierId === supplierId
    )
  },
  getSupplierMaxSortNumber: (state) => {
    return state.supplierMaxSortNumber
  },
  getSupplierIdNameListFromState: (state) => {
    return state.supplierIdNameList
  },
  getSuggestedReceivingLocationListFromState: (state) => {
    return state.suggestedReceivingLocationList
  },
  getSuggestedReceivingLocationMaxSortNumber: (state) => {
    return state.suggestedReceivingLocationMaxSortNumber
  },
  getSupplierIdNameAndDescriptionListFromState: (state) => {
    return state.supplierIdNameAndDescriptionList
  }
}

export default Getters
